export var EnergyType;
(function (EnergyType) {
    EnergyType["GAS"] = "gas";
    EnergyType["ELECTRICITY"] = "electricity";
})(EnergyType || (EnergyType = {}));
